import { Routes } from '@angular/router';
import { NotFoundPageComponent } from '@sb-tools/typescript/components/error-pages/not-found-page/not-found-page.component';
import { FormComponent } from './form/form.component';
import { FormDataResolverService } from './core/services/form-data-resolver.service';
import { FormMetaResolverService } from './core/services/form-meta-resolver.service';
import { FormsComponent } from './forms/forms.component';

export const routes: Routes = [
    { path: '404', component: NotFoundPageComponent },
    {
        path: 'survey',
        component: FormComponent,
        resolve: {
            formData: FormDataResolverService,
            formMeta: FormMetaResolverService,
        },
    },
    {
        path: ':community',
        component: FormComponent,
        resolve: {
            formData: FormDataResolverService,
            formMeta: FormMetaResolverService,
        },
    },
    {
        path: ':community/forms-list',
        component: FormsComponent,
    },
    {
        path: ':community/:formName',
        component: FormComponent,
        resolve: {
            formData: FormDataResolverService,
            formMeta: FormMetaResolverService,
        },
    },
    { path: '**', redirectTo: '404' },
];
